import { HamburgerMenu } from 'acscp/components/common/hamburgerMenu';
import { BrokerDetails } from 'acscp/components/auth/brokerDetails';
import React from 'react';
import { AccountPreferences } from 'acscp/components/auth/accountPreferences';
import { CustomerContactDetails } from 'acscp/components/auth/customerContactDetails';
import { NotificationBar } from 'acscp/components/common/notificationBar';
import { AccountMenu } from 'acscp/web/components/common/accountMenu';
import { MainMenu } from 'acscp/components/common/mainMenu';
import { ErrorBoundary } from 'acscp/components/common/errorBoundary';
import { Footer } from './footer';
import style from './pageLayout.module.scss';
import classNames from 'classnames';
import { ScrollToTopOnMount } from 'acscp/components/common/scrollToTopOnMount';
import { LanguageMenu } from '../intl/languageMenu';
import { StickyFooter } from 'acscp/components/common/stickyFooter/stickyFooter';
import { MobileStickyFooter } from 'acscp/components/common/stickyFooter/mobileStickyFooter';
import { AccountNotifications } from 'acscp/components/common/accountNotifications';

export function withPageLayout<P extends {}>(Wrapped: React.ComponentType<P>, tripCounterOnSamePage: boolean = false): React.ComponentType<P> {
    const PageLayout = (props: P) => (
        <ErrorBoundary>
            <div className={classNames(style.Body, SHOW_FOOTER && style.HasFooter, IS_MOBILE_APP && style.HasStickyHeader)} >
                <ScrollToTopOnMount />

                <NotificationBar />
                <AccountMenu useStickyHeader={IS_MOBILE_APP} />
                <MainMenu
                    tripCounterOnSamePage={tripCounterOnSamePage}
                    useStickyHeader={IS_MOBILE_APP}
                />
                <AccountPreferences/>
                <CustomerContactDetails />
                <LanguageMenu />
                <HamburgerMenu />
                <BrokerDetails />
                <div className={style.BodyContent}>
                    <Wrapped {...props} />
                </div>
                {SHOW_FOOTER && <Footer />}
                {IS_MOBILE_APP ? <MobileStickyFooter /> : <StickyFooter />}
                {IS_MOBILE_APP && <AccountNotifications />}
            </div>
        </ErrorBoundary>
    );
    return PageLayout;
}
